module.exports = __webpack_public_path__ + "h5/img/top2.e559ff13.png";